import { BUNDLE_CATEGORY_LIST_TAG } from '../constants';
import { api } from '../core';

interface ExtractToResponse {
  categoryId: string;
  categoryName: string;
  inBundles: boolean;
}

interface ExtractToBaseProps {
  bundleId: string;
  pageIds: string[];
  date: null | string;
}

interface ExtractToWithCategoryId extends ExtractToBaseProps {
  categoryId: string;
  categoryName: null;
}

interface ExtractToWithCategoryName extends ExtractToBaseProps {
  categoryId: null;
  categoryName: string;
}

type ExtractToProps = ExtractToWithCategoryId | ExtractToWithCategoryName;

const extractToApi = api.injectEndpoints({
  endpoints: (builder) => ({
    extractTo: builder.mutation<ExtractToResponse, ExtractToProps>({
      query: ({ bundleId, pageIds, categoryId, categoryName, date }: ExtractToProps) => ({
        url: 'bundle/extract-to',
        method: 'POST',
        body: {
          bundleId: bundleId,
          pageIds: pageIds,
          categoryId: categoryId,
          categoryName: categoryName,
          date: date,
        },
      }),
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;

          dispatch(api.util.invalidateTags([BUNDLE_CATEGORY_LIST_TAG]));
        } catch (error) {
          console.error('Error in extractTo in onQueryStarted:', error);
        }
      },
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useExtractToMutation } = extractToApi;
